export default __webpack_public_path__ + "static/media/ODWAGA.f059bacd.png";